import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../CommonComponent/Loader";
import { apiRequestPost } from "../../Helper/Api";
import Swal from "sweetalert2";
import {
  FaChevronDown,
  FaEye,
  FaEyeSlash,
  FaPhone,
  FaUser,
} from "react-icons/fa6";

const SignUp = () => {
  const navigate = useNavigate();
  const [noHp, setNoHp] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [username, setUsername] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    // persistor.purge();
    if (noHp.length < 10) {
      Swal.fire({
        title: "Gagal",
        text: "Harap menggunakan No.HP yang sesuai",
        icon: "error",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    }
    setLoading(true);
    try {
      const url = "/auth/register";
      const payload = {
        no_hp: noHp,
        username: username,
        roles: role,
        password: password,
      };
      const { error, result } = await apiRequestPost(url, payload);

      if (result) {
        Swal.fire({
          title: "Berhasil",
          text: "Akun super admin berhasil dibuat, silahkan login menggunakan akun tersebut",
          icon: "success",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        setTimeout(()=>{
          navigate("/");
        },1500)
      } else {
        Swal.fire({
          title: "Gagal",
          text: error,
          icon: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="flex flex-wrap items-center">
          <div className="hidden w-full xl:block xl:w-1/2">
            <div className="py-17.5 px-26 text-center">
              <Link className="mb-5.5 inline-block" to="/">
                <img
                  className="hidden dark:block"
                  src="https://gp-production-img.s3.ap-southeast-1.amazonaws.com/corp-img/logolight.png"
                  alt="Logo"
                  style={{ width: 200, height: "auto" }}
                />
                <img
                  className="dark:hidden"
                  src="https://gp-production-img.s3.ap-southeast-1.amazonaws.com/corp-img/logolight.png"
                  alt="Logo"
                  style={{ width: 200, height: "auto" }}
                />
              </Link>

              <p className="2xl:px-20">
                Memberdayakan Warung, dimana Tradisi Bertemu Inovasi
              </p>

              <span className="mt-15 inline-block">
                <img
                  src="https://gp-production-img.s3.ap-southeast-1.amazonaws.com/corp-img/logokucing.png"
                  alt="kucing-pink"
                />
              </span>
            </div>
          </div>

          <div className="w-full border-stroke dark:border-strokedark xl:w-1/2 xl:border-l-2">
            <div className="w-full p-4 sm:p-12.5 xl:p-17.5">
              <span className="mb-1.5 block font-medium"></span>
              <h2 className="mb-9 text-2xl font-bold text-black dark:text-white sm:text-title-xl2">
                Sign Up as an user POS Bersama
              </h2>

              <form className="">
                <div className="mb-4">
                  <label className="mb-2.5 block font-medium text-black dark:text-white">
                    No.Hp
                  </label>
                  <div className="relative flex items-center">
                    <input
                      type="number"
                      placeholder="EX. 08123456789"
                      className="w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-10 outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                      onChange={(e) => setNoHp(e.target.value)}
                    />

                    <span className="absolute right-4">
                      <FaPhone />
                    </span>
                  </div>
                </div>
                <div className="mb-6">
                  <label className="mb-2.5 block font-medium text-black dark:text-white">
                    Username
                  </label>
                  <div className="relative flex items-center">
                    <input
                      type="text"
                      placeholder="EX. John Wick"
                      className="w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-10 outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                      onChange={(e) => setUsername(e.target.value)}
                    />
                    <span className="absolute right-4">
                      <FaUser />
                    </span>
                  </div>
                </div>
                <div className="mb-6">
                  <label className="mb-2.5 block font-medium text-black dark:text-white">
                    Roles
                  </label>
                  <div className="relative flex items-center">
                    <select
                      className={`w-full rounded-lg border appearance-none border-stroke bg-transparent py-4 pl-6 pr-10 outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary `}
                      onChange={(e) => setRole(e.target.value)}
                    >
                      <option value="">Pilih Role</option>
                      <option value="4">SUPERADMIN</option>
                    </select>
                    <span className="absolute right-4">
                      <FaChevronDown />
                    </span>
                  </div>
                </div>

                <div className="mb-6">
                  <label className="mb-2.5 block font-medium text-black dark:text-white">
                    Password
                  </label>
                  <div className="relative flex items-center">
                    <input
                      type={show ? "text" : "password"}
                      placeholder="type your password"
                      className="w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-10 outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      className="absolute right-4 cursor-pointer"
                      onClick={() => setShow(!show)}
                    >
                      {show ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>

                <div className="mb-5">
                  <input
                    type="button"
                    value="Sign Up"
                    className="w-full cursor-pointer rounded-lg border border-bersama bg-bersama p-4 text-white transition hover:bg-opacity-90"
                    onClick={(e) => handleRegister(e)}
                  />
                </div>

                <div className="mt-6 text-center">
                  <p>
                    Already have an account?{" "}
                    <Link to="/auth/signin" className="text-primary">
                      Sign In
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
